var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDod = function SvgDod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 35.125c8.353 0 15.125-6.772 15.125-15.125S28.353 4.875 20 4.875 4.875 11.647 4.875 20 11.647 35.125 20 35.125"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 5.375c8.063 0 14.625 6.563 14.625 14.625S28.062 34.625 20 34.625 5.375 28.062 5.375 20 11.938 5.375 20 5.375m0-1c-8.625 0-15.625 7-15.625 15.625s7 15.625 15.625 15.625 15.625-7 15.625-15.625S28.625 4.375 20 4.375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 35.125c8.353 0 15.125-6.772 15.125-15.125S28.353 4.875 20 4.875 4.875 11.647 4.875 20 11.647 35.125 20 35.125"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 5.375c8.063 0 14.625 6.563 14.625 14.625S28.062 34.625 20 34.625 5.375 28.062 5.375 20 11.938 5.375 20 5.375m0-1c-8.625 0-15.625 7-15.625 15.625s7 15.625 15.625 15.625 15.625-7 15.625-15.625S28.625 4.375 20 4.375"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipPath: "url(#dod_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.97 22.737c.642.135 1.31-.022 1.772-.488l1.407-1.407 2.007 2.007-1.407 1.407c-.462.466-.619 1.134-.485 1.776a1.735 1.735 0 0 1-.772 1.82 1.73 1.73 0 0 1-1.903-.026 1.74 1.74 0 0 1-.75-1.664 1.74 1.74 0 0 1-1.663-.75 1.73 1.73 0 0 1-.03-1.902 1.74 1.74 0 0 1 1.824-.773m12.062-5.472c-.642-.135-1.31.022-1.776.485l-1.406 1.406-2.008-2.007 1.407-1.407c.466-.463.623-1.13.488-1.772-.138-.668.12-1.4.773-1.825a1.73 1.73 0 0 1 1.902.03c.582.4.828 1.049.75 1.664a1.74 1.74 0 0 1 1.664.75c.388.564.4 1.328.026 1.903a1.735 1.735 0 0 1-1.82.773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.257 22.25c.464.464 1.131.62 1.774.487a1.74 1.74 0 0 1 1.796 2.673 1.74 1.74 0 0 1-1.665.751 1.737 1.737 0 1 1-3.424-.13c.133-.643-.024-1.31-.488-1.774l-6.506-6.507c-.464-.464-1.131-.62-1.774-.487a1.74 1.74 0 0 1-1.824-.772 1.737 1.737 0 0 1 1.693-2.653 1.74 1.74 0 0 1 .752-1.665 1.74 1.74 0 0 1 2.672 1.796c-.133.643.023 1.31.487 1.774z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dod_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.875 28.125h16.25v-16.25h-16.25z"
  })))));
};
export default SvgDod;